import { OneSignal } from 'react-native-onesignal';
import { isWeb } from '../../config/designSystem/Layout';

export const requestPermission = async () => {
  if(!isWeb) {
    if( await OneSignal.Notifications.canRequestPermission()) {
      OneSignal.Notifications.requestPermission(true);
    }
  } else {
    return false;
  }
};